import { aboutData } from '@/mocks/about';

export default function FAQSection() {
  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 text-center mb-10">
          {aboutData.faq.title}
        </h2>
        <div className="space-y-4">
          {aboutData.faq.items.map((item, index) => (
            <details key={index} className="group bg-white rounded-lg border border-background-200 overflow-hidden">
              <summary className="flex items-center justify-between px-6 py-4 cursor-pointer hover:bg-background-50 transition-colors">
                <span className="text-sm md:text-base font-medium text-foreground-950 pr-4">
                  {item.question}
                </span>
                <span className="w-5 h-5 flex-shrink-0 flex items-center justify-center text-foreground-400 group-open:hidden">
                  <i className="ri-add-line"></i>
                </span>
                <span className="w-5 h-5 flex-shrink-0 flex items-center justify-center text-foreground-400 hidden group-open:flex">
                  <i className="ri-subtract-line"></i>
                </span>
              </summary>
              <div className="px-6 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}